"use client"
import { AspectRatio, Box, Card, Flex, Grid, Image, Text, Title } from "@mantine/core";
import { COLORS, CONTACTS, SOCIAL_LINKS } from "src/constants";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Content } from "src/shared/helpers/content";

export const ContactsWidget = () => {
    const { i18n } = useTranslation();
    const locale = i18n.language

    return (
        <Box mb={24}>
            <Title mb={24}>
                Контакты
            </Title>
            <Grid gutter={24}>
                <Grid.Col span={{ base: 12, sm: 5 }}>
                    <AspectRatio w="100%" ratio={5 / 3}>
                        <Card radius="xl">
                            <iframe
                                src="https://yandex.com/map-widget/v1/?ll=74.577688%2C42.828881&mode=search&oid=152734244071&ol=biz&sctx=ZAAAAAgBEAAaKAoSCfFmDd5XtSVAEXmxMEROl0hAEhIJ9N4YAoCNX0ARijpzDwn7R0AiBgABAgMEBSgKOABAkE5IAWoCdWGdAc3MzD2gAQCoAQC9AZIQo1jCAQbnua79uASCAjbQsy4g0JHQuNGI0LrQtdC6LCDQkdCw0LrQsNC10LLQsCAxNDAvMSwg0JHQpiBTa3kgUGxhemGKAgCSAgUxMDMwOZoCDGRlc2t0b3AtbWFwcw%3D%3D&sll=74.577688%2C42.828881&sspn=0.015407%2C0.006531&text=%D0%B3.%20%D0%91%D0%B8%D1%88%D0%BA%D0%B5%D0%BA%2C%20%D0%91%D0%B0%D0%BA%D0%B0%D0%B5%D0%B2%D0%B0%20140%2F1%2C%20%D0%91%D0%A6%20Sky%20Plaza&z=17"
                                width="100%" height="100%" frameBorder="0"
                                style={{ position: "relative", borderRadius: "16px" }}></iframe>
                        </Card>
                    </AspectRatio>
                </Grid.Col>
                <Grid.Col mt={16} span={{ base: 12, sm: 7 }}>
                    <Flex gap={16} direction="column">
                        <Box>
                            <Title mb={4} lh={1.2} c={COLORS.TRIOTERY_COLOR} fz={{ base: 24, sm: 28, lg: 32 }} fw={600}>
                                Адрес:
                            </Title>
                            <Text fz={18} c={COLORS.SECONDARY_COLOR} fw={400}>
                                {Content.GetTitleByLanguage(CONTACTS.ADDRESS, locale)}
                            </Text>
                        </Box>
                        <Box>
                            <Title mb={4} lh={1.2} c={COLORS.TRIOTERY_COLOR} fz={{ base: 24, sm: 28, lg: 32 }} fw={600}>
                                Почта:
                            </Title>
                            <a href="mailto:info@vent-fix.kg">
                                <Text fz={18} c={COLORS.SECONDARY_COLOR} fw={400}>
                                    info@vent-fix.kg
                                </Text>
                            </a>
                        </Box>
                        <Box>
                            <Title mb={4} lh={1.2} c={COLORS.TRIOTERY_COLOR} fz={{ base: 24, sm: 28, lg: 32 }} fw={600}>
                                Номер телефона:
                            </Title>
                            {CONTACTS.PHONE_NUMBER?.map(el => (
                                <Link key={el} to={`tel:${el}`}>
                                    <Text fz={18} c={COLORS.SECONDARY_COLOR} fw={400}>
                                        {el}
                                    </Text>
                                </Link>
                            ))}
                        </Box>
                        <Box>
                            <Title mb={4} lh={1.2} c={COLORS.TRIOTERY_COLOR} fz={{ base: 24, sm: 28, lg: 32 }} fw={600}>
                                Социалные ссылки:
                            </Title>
                            <Flex gap={16}>
                                {SOCIAL_LINKS?.map(el => (
                                    <Link key={el.link} to={el.link} target="_blank">
                                        <Image alt="" width={32} height={32} src={el.iconDark} />
                                    </Link>
                                ))}
                            </Flex>
                        </Box>
                    </Flex>
                </Grid.Col>
            </Grid>
        </Box>
    )
}